import { BaseModel } from './BaseModel';
import { AdditionalPortRange, Egg } from './Egg';
import { EggVariable } from './EggVariable';
import { ServerTemplateSchedule } from './ServerTemplateSchedule';

// Soft (default): a resync preserves the user's edited variables and any
// schedules they added. Hard: a resync resets those before re-applying the
// template.
export type ServerTemplateType = 'soft' | 'hard';

export class ServerTemplate extends BaseModel {
    public id = '';
    public name = '';
    public identifier: string | null = null;
    public type: ServerTemplateType = 'soft';

    public eggId = '';
    public nestId = '';
    public image = '';
    public startup = '';
    public skipScripts = false;

    // Catalog-driven flat map of every build/limit field, keyed by camelCased field name.
    public build: Record<string, unknown> = {};

    // Primary allocation range (comma-separated ports/ranges) a server created from
    // this template picks its primary port from. The egg no longer owns a range.
    public portRange: string | null = null;
    // Per-additional-port range overrides: each replaces an egg additional port's
    // offset/any_free rule with a fixed range for servers created from this template.
    public additionalPortRanges: AdditionalPortRange[] = [];

    // Build-field keys this template leaves unmanaged: blanked, and skipped by a
    // resync and by divergence (e.g. driven per order by a WHMCS configurable option).
    public unmanagedFields: string[] = [];
    // Egg variable ids this template leaves unmanaged, in the same sense.
    public unmanagedVariables: string[] = [];

    public serversCount?: number;

    public get egg(): Egg {
        return this.getRelationship('egg');
    }

    public get variables(): EggVariable[] {
        return this.getRelationship('variables') || [];
    }

    public get schedules(): ServerTemplateSchedule[] {
        return this.getRelationship('schedules') || [];
    }

    public getRouteName() {
        return 'serverTemplate';
    }

    public getRouteID(): string {
        return this.id;
    }
}
